import React, { useState, useEffect, useCallback, useRef } from 'react';
import BasicDrawer from '../../../components/Drawer';
import LabelWithSelect from '../../../components/LabelWithSelect';
import {
    Col,
    ConfigProvider,
    Modal,
    Row,
    Select,
    TimePicker,
    Switch,
    DatePicker,
    Spin,
    Tag,
    Timeline,
    Empty,
} from 'antd';
import { MdHistory } from 'react-icons/md';
import { Controller, useForm } from 'react-hook-form';
import BasicText from '../../../components/Text/BasicText';
import { ApiCaller, Colors, Utils } from '../../../config';
import { Button, TextField, buildPropertyOption } from '../../../components';
import { OpenShiftDetail } from '../../../config/Schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation, useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import {
    ShiftSchedulerAction,
    SiteManagementAction,
} from '../../../store/actions';
import useColors from '../../../hooks/useColors';
import {
    getAllUsers,
    getEligibiity,
    getPropertiesPage,
    getPropertyDetail,
} from '../../../config/getApis';
import dayjs from 'dayjs';
import { recurringFrequency, shiftBreaks } from '../../../config/variables';

let usersStatus = 'active';

const DetailShiftDrawer = ({
    drawerStates,
    setDrawerStates,
    openShiftDetailData,
    state,
    setState,
    setAssignShiftCase,
    setOpenShiftDetail = () => { },
}) => {
    const { colorPrimary, colorSecondary } = useColors();
    const dateFormat = useSelector((state) => state.AppReducer?.dateFormat);
    const timeFormat = useSelector((state) => state.AppReducer?.timeFormat);
    console.log(openShiftDetailData, 'openShiftDetailData');

    const schema = OpenShiftDetail;
    const dispatch = useDispatch();

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [pendingDeleteId, setPendingDeleteId] = useState(null);
    const [historyDrawer, setHistoryDrawer] = useState({ open: false, items: [], loading: false });
    const user = useSelector((state) => state.AppReducer?.user);
    const isRole = user?.userRole[0];

    // Properties arrive one page at a time from the dropdown itself (search +
    // infinite scroll); cache the raw objects we have seen.
    const propertyCacheRef = useRef({});

    // Property dropdown options come from the shared builder so every screen
    // renders them the same way; caching the raw object lets us derive
    // addresses/locations for whichever property gets selected.
    const toPropertyOption = (p) => {
        propertyCacheRef.current[p.id] = p;
        return buildPropertyOption(p);
    };

    const fetchPropertiesPage = useCallback(async ({ page, search }) => {
        const { data, hasMore } = await getPropertiesPage({ page, search });
        return { options: data.map(toPropertyOption), hasMore };
    }, []);

    const [selectedProperty, setSelectedProperty] = useState(null);

    // Keeps the selected property visible even when it is not on a loaded page
    const selectedPropertyOption = selectedProperty
        ? [toPropertyOption(selectedProperty)]
        : [];

    // Resolves a property id to its full object (cache first, API otherwise)
    const resolveProperty = async (id) => {
        if (!id) return null;
        const cached = propertyCacheRef.current[id];
        if (cached?.addresses || cached?.locations) return cached;
        const detail = await getPropertyDetail(id);
        if (detail) propertyCacheRef.current[id] = detail;
        return detail || cached || null;
    };

    const addressOptions = (selectedProperty?.addresses || []).map((addr) => ({
        label: [
            addr.streetNumber,
            addr.streetName,
            addr.city,
            addr.state,
            addr.zip,
        ]
            .filter(Boolean)
            .join(', '),
        value: addr.id,
    }));

    const locationOptions = (selectedProperty?.locations || []).map((loc) => ({
        label: loc.name,
        value: loc.id,
    }));

    const { data: elegibilityOptions } = useQuery(
        'eligibilites',
        getEligibiity,
        {
            enabled: drawerStates.openShiftDetailDrawer,
        },
    );

    const { data: userOptions } = useQuery(
        ['users', { usersStatus }],
        () => getAllUsers('', usersStatus),
        {
            enabled: drawerStates.openShiftDetailDrawer,
        },
    );

    const { handleSubmit, control, reset, watch, setValue } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if (openShiftDetailData) {
            console.log(openShiftDetailData, 'openShiftDetailData');

            // Extract user IDs from shiftUser array
            let assignedUserIds = [];
            if (
                openShiftDetailData.shiftUser &&
                openShiftDetailData.shiftUser.length > 0
            ) {
                assignedUserIds = openShiftDetailData.shiftUser
                    .map((shiftUser) => {
                        return shiftUser.user?.id || shiftUser.assignee?.id;
                    })
                    .filter((id) => id !== undefined);
            }

            reset({
                usersId: assignedUserIds,
                startTime: openShiftDetailData.startTime
                    ? dayjs(openShiftDetailData.startTime, 'HH:mm')
                    : null,
                endTime: openShiftDetailData.endTime
                    ? dayjs(openShiftDetailData.endTime, 'HH:mm')
                    : null,
                shiftDate: openShiftDetailData.shiftDate
                    ? dayjs(openShiftDetailData.shiftDate)
                    : null,
                startDate: openShiftDetailData.startDate
                    ? dayjs(openShiftDetailData.startDate)
                    : openShiftDetailData?.shiftDate ? dayjs(openShiftDetailData?.shiftDate) : null,
                endDate: openShiftDetailData.endDate
                    ? dayjs(openShiftDetailData.endDate)
                    : openShiftDetailData?.shiftDate ? dayjs(openShiftDetailData?.shiftDate) : null,
                propertyId: openShiftDetailData.property?.id,
                eligibilityId: openShiftDetailData.eligibilitity?.id,
                recurringFrequency: openShiftDetailData.recurringFrequency,
                break: openShiftDetailData.break,
                notes: openShiftDetailData.notes,
                published: openShiftDetailData.published ?? true,
                addressId: openShiftDetailData.address?.id || openShiftDetailData.addressId || '',
                locationId: openShiftDetailData.location?.id || openShiftDetailData.locationId || '',
            });

            if (openShiftDetailData.property?.id) {
                // Seed the cache with what the shift carries so the dropdown can
                // label it before the detail call resolves
                propertyCacheRef.current[openShiftDetailData.property.id] = {
                    ...(propertyCacheRef.current[
                        openShiftDetailData.property.id
                    ] || {}),
                    ...openShiftDetailData.property,
                };
                setSelectedProperty(
                    propertyCacheRef.current[openShiftDetailData.property.id],
                );
                resolveProperty(openShiftDetailData.property.id).then(
                    (property) => property && setSelectedProperty(property),
                );
            } else {
                setSelectedProperty(null);
            }
        }
    }, [
        openShiftDetailData,
        drawerStates.openShiftDetailDrawer,
        reset,
        dispatch,
    ]);

    const propertyApiHandler = async (value) => {
        setValue('addressId', '');
        setValue('locationId', '');
        if (!value) {
            setSelectedProperty(null);
            return;
        }
        const property = await resolveProperty(value);
        setSelectedProperty(property);
    };
    const userAcceptedMutation = useMutation(
        async (data) => {
            let resp = await ApiCaller.Post(
                `/shift/${openShiftDetailData?.id}/approve?direct_assign_by_admin=1`,
                data,
            );
            return resp;
        },
        {
            onSuccess: (resp) => {
                const { limit, page, tabKey, filterDrawer } = state;
                Utils.showMessage('success', resp?.data?.message);
                setDrawerStates({
                    ...drawerStates,
                    openShiftDetailDrawer: false,
                });
                // dispatch(
                //     ShiftSchedulerAction.GetShifts({
                //         limit: limit,
                //         tabKey: tabKey,
                //         page: page,
                //         filterDrawer,
                //     }),
                // );
                setState({
                    ...state,
                    limit: limit,
                    tabKey: tabKey,
                    page: page,
                    filterDrawer: { ...state.filterDrawer },
                });
                setAssignShiftCase(true);
                dispatch(ShiftSchedulerAction.ClearShifts());
            },
            onError: (err) => {
                Utils.showMessage('error', err?.response?.data?.message);
            },
        },
    );

    // Mutation to update shift details
    const shiftUpdateMutation = useMutation(
        async (data) => {
            // specific formatting if needed
            const payload = { ...data };
            // Time formatting
            if (payload.startTime)
                payload.startTime = dayjs(payload.startTime).format('HH:mm');
            if (payload.endTime)
                payload.endTime = dayjs(payload.endTime).format('HH:mm');

            // Date formatting
            if (payload.startDate)
                payload.startDate = dayjs(payload.startDate).format(
                    'YYYY-MM-DD',
                );
            if (payload.endDate)
                payload.endDate = dayjs(payload.endDate).format('YYYY-MM-DD');
            if (payload.shiftDate)
                payload.shiftDate = dayjs(payload.shiftDate).format(
                    'YYYY-MM-DD',
                );

            // Location Parsing
            if (
                payload.locationId &&
                typeof payload.locationId === 'string' &&
                payload.locationId.includes(',')
            ) {
                let addressStr = payload.locationId.split(',');
                let locationPart = addressStr[0];
                let addressPart = addressStr[1];

                let locId = locationPart.split(':')[1];
                let addrId = addressPart.split(':')[1];

                payload.locationId = locId;
                payload.addressId = addrId;
            }

            if (
                !payload.recurringFrequency ||
                payload.recurringFrequency === 'undefined'
            ) {
                delete payload.recurringFrequency;
            }

            if (payload.usersId) {
                payload.assignTo = payload.usersId;
                delete payload.usersId;
            }

            let resp = await ApiCaller.Put(
                `/shift/${openShiftDetailData?.id}`,
                payload,
            );
            return resp;
        },
        {
            onSuccess: (resp) => {
                const { limit, page, tabKey } = state;
                Utils.showMessage('success', resp?.data?.message);
                setDrawerStates({
                    ...drawerStates,
                    openShiftDetailDrawer: false,
                });
                setState({
                    ...state,
                    limit: limit,
                    tabKey: tabKey,
                    page: page,
                    filterDrawer: { ...state.filterDrawer },
                });
                setAssignShiftCase(true);
                dispatch(ShiftSchedulerAction.ClearShifts());
            },
            onError: (err) => {
                Utils.showMessage('error', err?.response?.data?.message);
            },
        },
    );

    const deleteShiftMutation = useMutation(
        async (shiftId) => {
            let resp = await ApiCaller.Delete(`/shift/${shiftId}`);
            return resp;
        },
        {
            onSuccess: (resp) => {
                Utils.showMessage('success', resp?.data?.message || 'Shift deleted successfully');
                setShowDeleteConfirm(false);
                setPendingDeleteId(null);
                setDrawerStates({ ...drawerStates, openShiftDetailDrawer: false });
                setOpenShiftDetail(null);
                setAssignShiftCase(true);
                dispatch(ShiftSchedulerAction.ClearShifts());
            },
            onError: (err) => {
                Utils.showMessage('error', err?.response?.data?.message || 'Failed to delete shift');
                setShowDeleteConfirm(false);
                setPendingDeleteId(null);
            },
        },
    );

    const shiftUpdateHandler = (data) => {
        if (!data.published) {
            Utils.showMessage('error', 'Please mark as published to update');
            return;
        }
        shiftUpdateMutation.mutate({
            ...data,
            shiftDate: data?.startDate,
            isPublished: data?.published,
        });
    };

    const handleSeeHistory = async () => {
        if (!openShiftDetailData?.id) return;
        setHistoryDrawer({ open: true, items: [], loading: true });
        try {
            const resp = await ApiCaller.Get(`/shift/${openShiftDetailData.id}`);
            const items = resp?.data?.data?.shiftHistory?.items || resp?.data?.data?.history || [];
            setHistoryDrawer({ open: true, items, loading: false });
        } catch {
            setHistoryDrawer({ open: true, items: [], loading: false });
        }
    };

    const afterDrawerClose = () => {
        if (!drawerStates?.openShiftDetailDrawer) {
            // Reset all form fields to default/empty state
            reset({
                usersId: [],
                startTime: null,
                endTime: null,
                shiftDate: null,
                startDate: null,
                endDate: null,
                propertyId: undefined,
                eligibilityId: undefined,
                recurringFrequency: undefined,
                break: undefined,
                notes: '',
                published: true,
                locationId: '',
            });
        }
    };

    return (
        <div>
            <BasicDrawer
                openDrawer={drawerStates.openShiftDetailDrawer}
                width={500}
                title={openShiftDetailData?.openShift ? 'Open Shift Details' : 'Normal Shift Details'}
                onClose={() => {
                    setDrawerStates({
                        ...drawerStates,
                        openShiftDetailDrawer: false,
                    }),
                        setOpenShiftDetail(null)
                }}
                afterOpenChange={afterDrawerClose}
                children={
                    <>
                        <form>
                            <Row gutter={[16, 32]} className="mb-3">
                                <Col lg={24} md={24} sm={24} xs={24}>
                                    <Controller
                                        name="usersId"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <LabelWithSelect
                                                    mode={'multiple'}
                                                    options={
                                                        userOptions?.length > 0
                                                            ? userOptions
                                                            : []
                                                    }
                                                    labeltext={'Assign To'}
                                                    field={field}
                                                    showSearch={true}
                                                    labelClass={'font-normal'}
                                                    inputClass={
                                                        'outline-none py-1 rounded'
                                                    }
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                {/* <Col
                                    lg={11}
                                    md={11}
                                    sm={12}
                                    xs={12}
                                    className=""
                                >
                                    <Controller
                                        name="break"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <div className="">
                                                <LabelWithSelect
                                                    options={shiftBreaks}
                                                    labeltext={'Un-paid Break'}
                                                    field={field}
                                                    labelClass={'font-normal'}
                                                    inputClass={
                                                        'outline-none py-1 rounded h-9'
                                                    }
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                .message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col> */}
                            </Row>

                            <Row gutter={[16, 32]} className="mb-3">
                                <Col lg={13} md={13} sm={12} xs={12}>
                                    <Controller
                                        name="startTime"
                                        control={control}
                                        render={({
                                            field: { value, onChange },
                                            fieldState,
                                        }) => (
                                            <div className="flex flex-col">
                                                <label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    className="font-normal"
                                                >
                                                    Start Time
                                                </label>
                                                <ConfigProvider
                                                    theme={{
                                                        components: {
                                                            DatePicker: {
                                                                optionSelectedBg:
                                                                    colorPrimary,
                                                                optionActiveBg:
                                                                    Colors.LightGray,
                                                                optionSelectedColor:
                                                                    Colors.White,
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <TimePicker
                                                        value={value}
                                                        minuteStep={15}
                                                        use12Hours={timeFormat?.includes('A')}
                                                        format={timeFormat}
                                                        onChange={onChange}
                                                        className="outline-none py-1 rounded-md h-9"
                                                    />
                                                </ConfigProvider>
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>

                                <Col
                                    lg={11}
                                    md={11}
                                    sm={12}
                                    xs={12}
                                    className=""
                                >
                                    <Controller
                                        name="endTime"
                                        control={control}
                                        render={({
                                            field: { value, onChange },
                                            fieldState,
                                        }) => (
                                            <div className="flex flex-col">
                                                <label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    className="font-normal"
                                                >
                                                    End Time
                                                </label>
                                                <ConfigProvider
                                                    theme={{
                                                        components: {
                                                            DatePicker: {
                                                                optionSelectedBg:
                                                                    colorPrimary,
                                                                optionActiveBg:
                                                                    Colors.LightGray,
                                                                optionSelectedColor:
                                                                    Colors.White,
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <TimePicker
                                                        value={value}
                                                        minuteStep={15}
                                                        use12Hours={timeFormat?.includes('A')}
                                                        format={timeFormat}
                                                        onChange={onChange}
                                                        className="outline-none py-1 rounded-md h-9"
                                                    />
                                                </ConfigProvider>
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                            </Row>

                            <Row gutter={[16, 32]} className="mb-3">
                                <Col lg={13} md={13} sm={12} xs={12}>
                                    <Controller
                                        name="propertyId"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <div>
                                                <LabelWithSelect
                                                    fetchPage={
                                                        fetchPropertiesPage
                                                    }
                                                    showFullLabelToggle
                                                    enabled={
                                                        drawerStates.openShiftDetailDrawer
                                                    }
                                                    extraOptions={
                                                        selectedPropertyOption
                                                    }
                                                    placeholder="Search property site"
                                                    labeltext={'Property Site'}
                                                    field={field}
                                                    labelClass={'font-normal'}
                                                    inputClass={
                                                        'outline-none py-1 rounded h-9'
                                                    }
                                                    onChange={(value) => {
                                                        field.onChange(value);
                                                        propertyApiHandler(
                                                            value,
                                                        );
                                                    }}
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>

                                <Col
                                    lg={11}
                                    md={11}
                                    sm={12}
                                    xs={12}
                                    className=""
                                >
                                    <Controller
                                        name="eligibilityId"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <div>
                                                <LabelWithSelect
                                                    options={
                                                        elegibilityOptions
                                                            ? elegibilityOptions
                                                            : []
                                                    }
                                                    labeltext={'Eligibility'}
                                                    field={field}
                                                    labelClass={'font-normal'}
                                                    inputClass={
                                                        'outline-none py-1 rounded h-9'
                                                    }
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                            </Row>

                            <Row gutter={[16, 32]} className="mb-3">
                                <Col lg={13} md={13} sm={12} xs={12}>
                                    <Controller
                                        name="startDate"
                                        control={control}
                                        render={({
                                            field: { value, onChange },
                                            fieldState,
                                        }) => (
                                            <div className="flex flex-col">
                                                <label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    className="font-normal"
                                                >
                                                    Date
                                                </label>
                                                <DatePicker
                                                    className="outline-none py-1 rounded-md h-9 w-full"
                                                    allowClear={true}
                                                    format={dateFormat}
                                                    value={value}
                                                    onChange={onChange}
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>

                                {/* <Col
                                    lg={11}
                                    md={11}
                                    sm={12}
                                    xs={12}
                                    className=""
                                >
                                    <Controller
                                        name="endDate"
                                        control={control}
                                        render={({
                                            field: { value, onChange },
                                            fieldState,
                                        }) => (
                                            <div className="flex flex-col">
                                                <label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    className="font-normal"
                                                >
                                                    End Date
                                                </label>
                                                <DatePicker
                                                    className="outline-none py-1 rounded-md h-9 w-full"
                                                    allowClear={true}
                                                    format={dateFormat}
                                                    value={value}
                                                    onChange={onChange}
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col> */}
                            </Row>

                            <Row gutter={[16, 32]} className="mb-3">
                                <Col lg={13} md={13} sm={12} xs={12}>
                                    <Controller
                                        name="recurringFrequency"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <div>
                                                <LabelWithSelect
                                                    options={recurringFrequency}
                                                    labeltext="Repeat Shift"
                                                    field={field}
                                                    labelClass="font-normal"
                                                    inputClass="outline-none py-1 rounded h-9"
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>

                                <Col
                                    lg={11}
                                    md={11}
                                    sm={12}
                                    xs={12}
                                    className=""
                                >
                                    <Controller
                                        name="locationId"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <div>
                                                <LabelWithSelect
                                                    items={locationOptions}
                                                    placeholder="Search location"
                                                    labeltext={'Location'}
                                                    field={field}
                                                    labelClass={'font-normal'}
                                                    inputClass={
                                                        'outline-none py-1 rounded h-9'
                                                    }
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                            </Row>

                            <Row gutter={[16, 32]} className="mb-3">
                                <Col span={24} className="">
                                    <Controller
                                        name="notes"
                                        control={control}
                                        render={({
                                            field: { value, onChange },
                                            fieldState,
                                        }) => (
                                            <div>
                                                <TextField.Textarea
                                                    style={{
                                                        color: Colors.LightGray,
                                                    }}
                                                    placeholder={''}
                                                    value={value}
                                                    onChange={onChange}
                                                    labeltext={'Notes'}
                                                    className={
                                                        'outline-none h-10 rounded'
                                                    }
                                                    rows={4}
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                            </Row>

                            {/* Published toggle */}
                            <Row className="mb-4 mt-6">
                                <Col span={24} className="flex items-center">
                                    <Controller
                                        name="published"
                                        control={control}
                                        render={({
                                            field: { value, onChange },
                                        }) => (
                                            <div className="flex items-center gap-3">
                                                <Switch
                                                    checked={value}
                                                    onChange={onChange}
                                                    disabled={
                                                        openShiftDetailData?.published
                                                    }
                                                    className="custom-switch"
                                                    style={{
                                                        '--myColor': colorPrimary,
                                                    }}
                                                />
                                                <span
                                                    className="font-medium"
                                                    style={{ color: Colors.LabelColor }}
                                                >
                                                    {value ? 'Published' : 'Draft'}
                                                </span>
                                            </div>
                                        )}
                                    />
                                </Col>
                            </Row>

                            {/* Action buttons */}
                            <Row gutter={[8, 0]} className="mb-6">
                                <Col flex="1">
                                    <Button.Basic
                                        onClick={handleSeeHistory}
                                        size={'large'}
                                        text={
                                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                                <MdHistory size={16} />
                                                History
                                            </span>
                                        }
                                        buttonStyle={{
                                            backgroundColor: colorPrimary,
                                            color: 'white',
                                            width: '100%',
                                        }}
                                        className={'rounded-md h-10'}
                                    />
                                </Col>
                                {isRole === 'admin' && (
                                    <Col flex="1">
                                        <Button.Basic
                                            onClick={() => {
                                                setPendingDeleteId(openShiftDetailData?.id);
                                                setShowDeleteConfirm(true);
                                            }}
                                            size={'large'}
                                            text={'Delete'}
                                            buttonStyle={{
                                                backgroundColor: Colors.Error,
                                                color: 'white',
                                                width: '100%',
                                            }}
                                            className={'rounded-md h-10'}
                                        />
                                    </Col>
                                )}
                                {(isRole === 'admin' || isRole === 'supervisor') && (
                                    <Col flex="1">
                                        <Button.Basic
                                            onClick={handleSubmit(shiftUpdateHandler)}
                                            htmlType="submit"
                                            loader={shiftUpdateMutation.isLoading}
                                            size={'large'}
                                            text={'Update'}
                                            buttonStyle={{
                                                backgroundColor: colorPrimary,
                                                color: 'white',
                                                width: '100%',
                                            }}
                                            className={'rounded-md h-10'}
                                        />
                                    </Col>
                                )}
                            </Row>
                        </form>
                    </>
                }
            />

            {/* Shift History Drawer */}
            <BasicDrawer
                openDrawer={historyDrawer.open}
                width={480}
                title={
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MdHistory size={18} color="#6366f1" />
                        Shift History
                    </span>
                }
                onClose={() => setHistoryDrawer({ open: false, items: [], loading: false })}
                children={
                    <div style={{ padding: '4px 0' }}>
                        {historyDrawer.loading ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                                <Spin size="large" />
                            </div>
                        ) : historyDrawer.items.length === 0 ? (
                            <Empty description="No history available" style={{ marginTop: '60px' }} />
                        ) : (
                            <Timeline
                                mode="left"
                                items={historyDrawer.items.map((item) => ({
                                    color: '#6366f1',
                                    label: (
                                        <div style={{ fontSize: '11px', color: '#888', minWidth: '110px' }}>
                                            {item.changedAt
                                                ? new Date(item.changedAt).toLocaleString()
                                                : '-'}
                                        </div>
                                    ),
                                    children: (
                                        <div
                                            style={{
                                                background: '#f9f9ff',
                                                border: '1px solid #e0e0f0',
                                                borderRadius: '8px',
                                                padding: '10px 14px',
                                                marginBottom: '4px',
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                                <Tag color="purple" style={{ fontSize: '11px', margin: 0 }}>
                                                    {item.event || 'event'}
                                                </Tag>
                                                <span style={{ fontWeight: 600, fontSize: '13px' }}>
                                                    {item.description || ''}
                                                </span>
                                            </div>

                                            {item.changedBy && (
                                                <div style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>
                                                    By:{' '}
                                                    <strong>
                                                        {item.changedBy.firstName} {item.changedBy.lastName}
                                                    </strong>{' '}
                                                    ({item.changedBy.email})
                                                </div>
                                            )}

                                            {item.fieldChanges && Object.keys(item.fieldChanges).length > 0 && (
                                                <div style={{ marginTop: '6px' }}>
                                                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px', fontWeight: 600 }}>
                                                        Field Changes:
                                                    </div>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                        {Object.entries(item.fieldChanges)
                                                            .filter(([, v]) => v?.new !== null && v?.new !== undefined)
                                                            .map(([key, val]) => (
                                                                <div
                                                                    key={key}
                                                                    style={{
                                                                        background: '#eef0ff',
                                                                        borderRadius: '4px',
                                                                        padding: '2px 6px',
                                                                        fontSize: '11px',
                                                                        color: '#444',
                                                                    }}
                                                                >
                                                                    <span style={{ color: '#6366f1', fontWeight: 600 }}>{key}:</span>{' '}
                                                                    {val?.old !== null && val?.old !== undefined
                                                                        ? `${String(val.old)} → ${String(val.new)}`
                                                                        : String(val.new)}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            )}

                                            {item.assignmentChanges?.added?.length > 0 && (
                                                <div style={{ marginTop: '6px' }}>
                                                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px', fontWeight: 600 }}>
                                                        Assigned:
                                                    </div>
                                                    {item.assignmentChanges.added.map((a) => (
                                                        <Tag key={a.shiftUserId} color="green" style={{ fontSize: '11px' }}>
                                                            {a.user?.firstName} {a.user?.lastName}
                                                        </Tag>
                                                    ))}
                                                </div>
                                            )}

                                            {item.assignmentChanges?.removed?.length > 0 && (
                                                <div style={{ marginTop: '6px' }}>
                                                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px', fontWeight: 600 }}>
                                                        Removed:
                                                    </div>
                                                    {item.assignmentChanges.removed.map((a) => (
                                                        <Tag key={a.shiftUserId} color="red" style={{ fontSize: '11px' }}>
                                                            {a.user?.firstName} {a.user?.lastName}
                                                        </Tag>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ),
                                }))}
                            />
                        )}
                    </div>
                }
            />

            {/* Delete shift confirmation */}
            <Modal
                title="Delete Shift"
                open={showDeleteConfirm}
                onCancel={() => { setShowDeleteConfirm(false); setPendingDeleteId(null); }}
                footer={null}
                width={380}
                centered
                zIndex={2000}
            >
                <div className="py-2">
                    <p className="text-sm text-gray-600 mb-6">
                        Are you sure you want to delete this shift? This action cannot be undone.
                    </p>
                    <div className="flex justify-end gap-3">
                        <Button.Basic
                            text="Cancel"
                            onClick={() => { setShowDeleteConfirm(false); setPendingDeleteId(null); }}
                            className="h-9 px-5 border rounded"
                            style={{
                                background: 'transparent',
                                color: colorPrimary,
                                border: `1px solid ${colorPrimary}`,
                            }}
                        />
                        <Button.Basic
                            text="Delete"
                            loader={deleteShiftMutation.isLoading}
                            onClick={() => deleteShiftMutation.mutate(pendingDeleteId)}
                            className="h-9 px-5 border-none text-white"
                            style={{ backgroundColor: Colors.Error }}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default DetailShiftDrawer;
